

















































































































































































import { Component } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { Page } from '@/core/components/controls';
import {
    DxDiagram,
    DxToolbox,
    DxGroup,
    DxCustomShape,
    DxNodes,
    DxHistoryToolbar,
    DxViewToolbar,
    DxMainToolbar,
    DxCommand,
} from 'devextreme-vue/diagram';
import 'whatwg-fetch';
import { CONTRACTS, EventsServiceContract, Events } from '@/core/contracts';
import ArrayStore from 'devextreme/data/array_store';
import { dxSelectBoxOptions } from 'node_modules/devextreme/ui/select_box';
import { dxButtonOptions } from 'node_modules/devextreme/ui/button';
import {
    DxForm,
    DxSimpleItem,
    DxButtonItem,
    DxGroupItem,
} from 'devextreme-vue/form';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { DxPopup } from 'devextreme-vue/popup';
import { Scheme } from '@/dto';

@Component({
    components: {
        DxButtonItem,
        DxCommand,
        DxCustomShape,
        DxDiagram,
        DxForm,
        DxGroup,
        DxGroupItem,
        DxHistoryToolbar,
        DxItem,
        DxMainToolbar,
        DxNodes,
        DxPopup,
        DxSimpleItem,
        DxToolbar,
        DxToolbox,
        DxViewToolbar,
    },
})
export default class CargoPlacementPage extends Page {
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;
    private currentSchemeId?: string = undefined;
    private schemeInfo?: Scheme = {
        id: '',
        name: '',
        jsonScheme: '',
        width: 20,
        height: 15,
    };
    private schemeList: string[] = [];
    private popupVisible: boolean = false;
    private diagram: any = {};
    private mainArea = {
        id: 'mainArea',
        type: 'area',
        width: this.schemeInfo?.width,
        height: this.schemeInfo?.height,
        top: -5,
        left: -5,
    };
    private orgItemsDataSource = new ArrayStore({
        key: 'id',
        data: [this.mainArea],
    });

    private selectBoxOptions: dxSelectBoxOptions = {
        width: 140,
        valueExpr: 'id',
        displayExpr: 'text',
        onValueChanged: args => {},
    };

    private addButtonOptions: dxButtonOptions = {
        icon: 'add',
        disabled: !this.isExistScheme,
        onClick: () => {},
    };

    private saveButtonOptions: dxButtonOptions = {
        icon: 'floppy',
        onClick: () => this.saveScheme(),
    };

    private editButtonOptions: dxButtonOptions = {
        icon: 'edit',
        onClick: () => {},
    };

    private deleteButtonOptions: dxButtonOptions = {
        icon: 'remove',
        onClick: () => {},
    };

    private buttonOptions: dxButtonOptions = {
        text: this.editFormTitle,
        type: 'success',
        useSubmitBehavior: true,
    };

    private saveScheme() {
        if (this.isExistScheme === false) {
            this.popupVisible = true;
        }
    }

    private async mounted() {
        this.diagram = (this.$refs.diagram as DxDiagram).instance;

        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    private async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    private submitForm(e: any) {}

    private async load() {}

    private itemStyleExpr(obj: any) {
        const style = {
            'fill': 'none',
            'stroke': '#333333',
            'opacity': 1,
            'stroke-dasharray': 0,
            'fill-opacity': 0.5,
        };

        switch (obj.type) {
            case 'area':
                style.stroke = '#92d0a1';
                style['stroke-dasharray'] = 5;
                style['fill-opacity'] = 0;
                break;
            case 'rack':
                style.fill = '#deffe3';
                style.stroke = '#92d0a1';
                break;
            case 'storage':
                style.fill = '#fff3af';
                style.stroke = '#c2c59d';
                break;
            case 'pack':
                if (!this.includedRect(obj, this.mainArea)) {
                    style.fill = '#ff0000';
                    style.stroke = '#ff0000';
                } else {
                    style.fill = '#c7ad6b';
                    style.stroke = '#c7ad6b';
                }
                break;
            default:
                break;
        }

        return style;
    }

    private itemTypeExpr(obj: any, value: any) {
        if (value) {
            obj.type = value;
        } else {
            return obj.type;
        }
    }

    private itemWidthExpr(obj: any, value: any) {
        if (value) {
            obj.width = value;
        } else {
            return obj.width;
        }
    }

    private itemHeightExpr(obj: any, value: any) {
        if (value) {
            obj.height = value;
        } else {
            return obj.height;
        }
    }

    private itemTopExpr(obj: any, value: any) {
        if (value) {
            obj.top = value;
        } else {
            return obj.top;
        }
    }

    private itemLeftExpr(obj: any, value: any) {
        if (value) {
            obj.left = value;
        } else {
            return obj.left;
        }
    }

    private itemZIndexExpr(obj: any, value: any) {
        if (value) {
            obj.zIndex = value;
        } else {
            return obj.zIndex;
        }
    }

    private onProcessingFinished({ contextId }: any) {}

    private get editFormTitle() {
        if (!this.isExistScheme) {
            return this.$l.CargoPlacement.SchemePicker.Save;
        } else {
            return this.$l.CargoPlacement.SchemePicker.Edit;
        }
    }

    private get isExistScheme() {
        return this.currentSchemeId !== undefined;
    }

    private includedRect(r2: any, r1: any) {
        return (
            r1.left <= r2.left &&
            r2.left + r2.width <= r1.left + r1.width &&
            r1.top <= r2.top &&
            r2.top + r2.height <= r1.top + r1.height
        );
    }
}
